import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import MapPin from './MapPin';
import * as types from '../../lib/constants';
import config from '../../config';
import '../../styles/map.css';
import expand from '../../images/googleMap/googlemap_expand.png';
import contract from '../../images/googleMap/googlemap_contract.png';

const {
  googleMapApiKey,
  mapDefaultLat: strMapDefaultLat,
  mapDefaultLng: strMapDefaultLng,
} = config;

const Main = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
const IconImage = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 25px;
  height: 25px;
  margin: 5px;
  cursor: pointer;
`;

const InitialMap = ({ center, markers, onClickMarker }) => {
  const [mapref, setMapRef] = useState(null);
  const [mapCenter, setMapCenter] = useState(center);
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: googleMapApiKey,
  });
  if (center.lat !== mapCenter.lat || center.lng !== mapCenter.lng) {
    setMapCenter(center);
  }

  if (loadError) {
    return 'Load Error';
  }

  const changeMapCenter = () => {
    if (mapref) {
      const newCenter = mapref.getCenter();
      setMapCenter({ lat: newCenter.lat(), lng: newCenter.lng() });
    }
  };
  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      options={types.GOOGLE_MAP_DEFAULT_OPTIONS_MEDIA}
      zoom={types.GOOGLE_MAP_DEFAULT_ZOOM}
      mapTypeId="roadmap"
      center={mapCenter}
      onLoad={map => setMapRef(map)}
      onDragEnd={() => changeMapCenter()}
      onZoomChanged={() => changeMapCenter()}
    >
      {markers.length > 0 &&
        markers.map((marker, index) => (
          <MapPin
            key={marker.operatorId}
            marker={marker}
            zIndex={index}
            onClickMarker={onClickMarker}
          />
        ))}
    </GoogleMap>
  ) : (
    'Loading...'
  );
};
InitialMap.propTypes = {
  center: PropTypes.object.isRequired,
  markers: PropTypes.array.isRequired,
  onClickMarker: PropTypes.func.isRequired,
};

const Map = ({ operators, mapCenterSite, fullscreen, onSelectOperator }) => {
  const linkTo = (fullscreen && '/ds/') || '/ds/map';
  const linkToImage = (fullscreen && contract) || expand;
  const { lat = Number(strMapDefaultLat), lng = Number(strMapDefaultLng) } =
    mapCenterSite;
  const center = { lat, lng };
  const markers = operators
    .slice()
    .reverse()
    .filter(operator => operator.lat !== null && operator.lng !== null);
  return (
    <Main>
      <InitialMap
        center={center}
        markers={markers}
        onClickMarker={onSelectOperator}
      />
      <Link to={linkTo}>
        <IconImage
          id="clickMapButton"
          role="presentation"
          alt="fullscreenButton"
        >
          <img src={linkToImage} alt="mapOpenCloseButton" />
        </IconImage>
      </Link>
    </Main>
  );
};

Map.propTypes = {
  operators: PropTypes.array.isRequired,
  mapCenterSite: PropTypes.object.isRequired,
  fullscreen: PropTypes.bool.isRequired,
  onSelectOperator: PropTypes.func.isRequired,
};

export default Map;
